import ajax from './ajax'
import axios from 'axios'


export const reqOpenWx = ()=>axios.get('https://s.whte.cn/cippe/openWx')
// export const reqOpenWx = (url)=>axios.get('https://cx.vippe.cn/cippe/openWx',{params:{url}})
// export const reqOpenWx =()=>ajax("/cippe/openWx",{params:{ jsonp:'111'}})



//自动查询登录状态
// https://e.cippe.com.cn/login/islogin
export const reqAutoLogin = ()=>ajax("/login/islogin")
// 微信登录
// https://e.cippe.com.cn/weixin/oauth2?code=xxxxx&state=xxxxx
export const reqLogin = (code,state)=>ajax("/weixin/oauth2",{params:{code,state}})
// 退出登录
// https://e.cippe.com.cn/loginout
export const reqOutLogin = ()=>ajax("/loginout")
// 首页-> 热门展品
// http://e.cippe.com.cn/index/pro_list_ad
export const reqProListAd = ()=>ajax("/index/pro_list_ad")



// 展品页分类列表
// http://e.cippe.com.cn/listjson/exhibi
export const reqSortList = ()=>ajax("/listjson/exhibi")
//  展品页数据列表
// http://e.cippe.com.cn/listjson/zhanpinlist?proname=n&procate=3&p=3
export const reqExhibitList = (p,procate,proname)=>ajax("/listjson/zhanpinlist",{params:{proname,procate,p}})
//展品详情页
// http://e.cippe.com.cn/listjson/productinfo?proid=8952
export const reqDetails = (proid)=>ajax("/listjson/productinfo",{params:{proid}})


// 2是已收藏！！！！ 1是未收藏
// 展品详情页初始获取收藏状态   
// https://e.cippe.com.cn/collection/pro_coll?id=展品ID
export const reqProColl = (id)=>ajax("/collection/pro_coll",{params:{id}})
// 修改展品详情收藏状态
// https://e.cippe.com.cn/collection/pro_coll_do?id=展品ID
export const reqProCollDo = (id)=>ajax("/collection/pro_coll_do",{params:{id}})
// 询盘
// http://e.cippe.com.cn/note?pid=展品ID&content=询盘内容
export const reqAddNote = (pid,content)=>ajax("/note",{params:{pid,content}})

// 展品详情-发起意向订单
// http://e.cippe.com.cn/listjson/order_add
export const reqListjsonOrderAdd = (intentionData)=>ajax.post("/listjson/order_add",intentionData)


// 首发首创
export const reqNewProductsList = (p)=>ajax("/listjson/first_release",{params:{p}})
// 首发首创详情
export const reqNewProductsItem = (id)=>ajax("/listjson/releaseinfo",{params:{id}})


//展商页数据列表
// http://e.cippe.com.cn/listjson?corpname=南阳&booth=E3&p=3
export const reqExhibitorList = (p,booth,corpname)=>ajax("/listjson",{params:{corpname,booth,p}})
//展商详情页
// http://e.cippe.com.cn/listjson/corpinfo?id=展商ID
export const reqExhibitorDetail = (id)=>ajax("/listjson/corpinfo",{params:{id}})
// 展商详情页初始获取收藏状态
// https://e.cippe.com.cn/collection/corp_coll_do?id=展商OCID
export const reqCorpColl = (ocid)=>ajax("/collection/corp_coll",{params:{id:ocid}})
// 修改展商收藏状态
// https://e.cippe.com.cn/collection/corp_coll_do?id=展商OCID
export const reqCorpCollDo = (ocid)=>ajax("/collection/corp_coll_do",{params:{id:ocid}})
// 展商展品初始化约见状态
// https://e.cippe.com.cn/collection/corp_app?id=11076
export const reqCorpApp = (ocid)=>ajax("/collection/corp_app",{params:{id:ocid}})
// 修改展商展品约见状态
// https://e.cippe.com.cn/collection/corp_app_do?id=111154
// export const reqCorpAppDo = (preAboutData)=>ajax("/collection/corp_app_do",{params:preAboutData})
export const reqCorpAppDo = (preAboutData)=>ajax.post("/collection/corp_app_do",preAboutData)


// 供需顶部热门推荐
//http://e.cippe.com.cn/listjson/ad_list
export const reqListjson = ()=>ajax("/listjson/ad_list")

// 供需
export const reqSupply = (text,page=1,sortid)=>ajax('/gongxujson?do='+text+'&p='+page+'&sortid='+sortid)

// 供需排行前三
export const reqRanking = ()=>ajax("/gongxujson/gongxu_top")

// 供需上传图片
// http://e.cippe.com.cn/gongxujson/upload
export const reqUploadImage = (ocid)=>ajax.post("/gongxujson/upload",{params:{id:ocid}})

// 供需删除图片
//http://e.cippe.com.cn/gongxujson/delimg
export const reqDelImage = (imgurl)=>ajax.post("/gongxujson/delimg",{imgurl})

// 获取评论列表
// http://e.cippe.com.cn/gongxujson/comment?id=1440
export const reqComment = (id)=>ajax("/gongxujson/comment",{params:{id}})

// 添加供需信息接口
// http://e.cippe.com.cn/gongxujson/gongxu_add
export const reqRelease = (form)=>ajax.post("/gongxujson/gongxu_add",form)

// 添加评论接口
// http://e.cippe.com.cn/gongxujson/comment_add
export const reqComments = (form)=>ajax.post("/gongxujson/comment_add",form)


// 我的->展商收藏 接口
// http://e.cippe.com.cn/my/corp_coll
export const reqMyCorpColl = (p)=>ajax("/my/corp_coll",{params:{p}})

// 我的->展品收藏 接口
// http://e.cippe.com.cn/my/pro_coll
export const reqMyProColl = (p)=>ajax("/my/pro_coll",{params:{p}})

// 我的->已约展商
// http://e.cippe.com.cn/my/corp_app
export const reqMyCorpApp = (p)=>ajax("/my/corp_app",{params:{p}})

// 我的->采购/供应管理
// http://e.cippe.com.cn/my/gongxu?do=xu&p=1&sortid=
export const reqMyGongxu = (gongxu,p)=>ajax("/my/gongxu?do="+gongxu+"&p="+p)

// 我的-> (供应) (采购)-> 删除
//http://e.cippe.com.cn/my/gongxu_del?id=1321
export const reqMyGongxuDel = (id)=>ajax("/my/gongxu_del",{params:{id}})

// 我的 ->评论
// http://e.cippe.com.cn/my/comment
export const reqMyComment = (p)=>ajax("/my/comment",{params:{p}})

// 我的->评论 操 作   删除   接口
// http://e.cippe.com.cn/my/comment_del?id=1123
export const reqMyCommentDel = (id)=>ajax("/my/comment_del",{params:{id}})

// 获取验证码
// http://e.cippe.com.cn/send/send?mb=13000000000
export const reqSendCode = (mb)=>ajax("/send/send",{params:{mb}})

// 修改个人信息
// http://e.cippe.com.cn/my/myinfo_edit
export const reqMyinfoEdit = (form)=>ajax.post("/my/myinfo_edit",form)

// 我的->更新头像
// http://e.cippe.com.cn/my/topimg_update
// 上传头像文件的接口同上传供需图片接口
export const reqMyTopimgUpdate = (img)=>ajax.post("/my/topimg_update",{img})

// 我的->询盘
// http://e.cippe.com.cn/my/mynote
export const reqMynote = ()=>ajax("/my/mynote")

// 询盘详情内容
// http://e.cippe.com.cn/my/note_one?sendid=168&putid=595&pid=8955
export const reqMynoteOne = (sendid,putid,pid)=>ajax("/my/note_one",{params:{sendid,putid,pid}})

// 我的 -> 询盘-> 回复
// http://e.cippe.com.cn/my/mynote_add
export const reqMynoteAdd = (putid,pid,content)=>ajax.post("/my/mynote_add",{putid,pid,content})

// 我的-询盘每条消息-删除
//http://e.cippe.com.cn/my/note_one_del?id=76
export const reqNoteDel = (id)=>ajax("/my/note_one_del",{params:{id}})

// 展商认证接口
// http://e.cippe.com.cn/my/corp_auth
export const reqMyCorpAuth = (corpuser,corppass)=>ajax.post("/my/corp_auth",{corpuser,corppass})

// 展商认证完成后，自登录展商管理系统
// http://e.cippe.com.cn/my/jump_cippe
export const reqMyJumpCippe = ()=>ajax("/my/jump_cippe")

// 我的->观众邀约
// http://e.cippe.com.cn/my/corp_app_my
export const reqMyCorpAppMy = ()=>ajax("/my/corp_app_my")

// 我的-》展商约见-》取消约见
// http://e.cippe.com.cn/my/corp_app_off?id=1
export const reqCorpAppOff = (id)=>ajax("/my/corp_app_off",{params:{id}})

// 我的-》观众邀约-》忽略
// http://e.cippe.com.cn/my/corp_app_neglect?id=1
export const reqCorpAppNeglect = (id)=>ajax("/my/corp_app_neglect",{params:{id}})

// 我的->观众邀约   中状态更改  忽略
// http://e.cippe.com.cn/my/corp_app_status?id=约见ID
export const reqCorpAppStatus = (id)=>ajax("/my/corp_app_status",{params:{id}})

// 我的->意向订单 ->我发出的
// http://e.cippe.com.cn/my/order_to
export const reqMyOrderTo = ()=>ajax("/my/order_to")

// 我的->意向订单->我收到的
// http://e.cippe.com.cn/my/order_get
export const reqMyOrderGet = ()=>ajax("/my/order_get")

// 我的->意向订单->收到订单->确认
// http://e.cippe.com.cn/my/order_status?id=7
export const reqMyOrderStatus = (id)=>ajax("/my/order_status",{params:{id}})

// 我的 –》信息更新-》邮箱存在验证
// http://e.cippe.com.cn/my/check_email
export const reqEmail = (email)=>ajax.post("/my/check_email",{email})
